import { useState, useEffect, useCallback } from "react";

import { getOption, getUserOption } from "../apis/option";

export const useOptionData = (apiType = "admin"): { options: any[]; loading: boolean } => {
  const [options, setOptions] = useState<[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchOptionData = useCallback(async () => {
    setLoading(true);
    try {
      let optionData;
      if (apiType === "admin") {
        optionData = await getOption();
      } else {
        optionData = await getUserOption();
      }
      setOptions(optionData);
    } catch (error) {
      console.error("Failed to fetch options", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOptionData();
  }, [fetchOptionData]);

  return { options, loading };
};
